/**
 * Gift Promo - brinde com cupom no carrinho lateral.
 *
 * Configurado via theme settings (Brinde com cupom):
 * - quando o cliente aplica o cupom configurado e o cart atinge o valor
 *   minimo dentro da janela de datas, libera escolha de um brinde.
 * - o cupom é aplicado automaticamente no checkout Shopify via parametro
 *   `?discount=` na URL de finalização de compra.
 * - o desconto real (valor zero do brinde) e responsabilidade do cupom
 *   configurado no admin do Shopify ("compre X, leve Y gratis").
 */
(function () {
  "use strict";

  var STORAGE_KEY = "gift_coupon";
  var ATTR_KEY = "gift_coupon";
  var BRINDE_PROP = "_brinde";
  var BRINDE_COUPON_PROP = "_brinde_cupom";

  var config = null;
  var state = {
    coupon: null,
    selectedVariantByProduct: {},
    forceExpanded: false,
  };

  function readConfig() {
    var node = document.getElementById("GiftPromoData");
    if (!node) return { enabled: false };
    try {
      return JSON.parse(node.textContent || node.innerText || "{}");
    } catch (e) {
      return { enabled: false };
    }
  }

  function isWithinDateRange() {
    if (!config) return false;
    var now = new Date();
    if (config.start) {
      var start = new Date(config.start + "T00:00:00");
      if (!isNaN(start) && now < start) return false;
    }
    if (config.end) {
      var end = new Date(config.end + "T23:59:59");
      if (!isNaN(end) && now > end) return false;
    }
    return true;
  }

  function formatMoneyBR(cents) {
    if (window.formatMoney) {
      try {
        return window.formatMoney(cents);
      } catch (e) {
        // fallback abaixo
      }
    }
    var v = (cents / 100).toFixed(2).replace(".", ",");
    return "R$ " + v;
  }

  function getStoredCoupon() {
    try {
      return localStorage.getItem(STORAGE_KEY) || null;
    } catch (e) {
      return null;
    }
  }

  function setStoredCoupon(code) {
    try {
      if (code) localStorage.setItem(STORAGE_KEY, code);
      else localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function normalizeCode(code) {
    return (code || "").toString().trim().toUpperCase();
  }

  function findGiftItem(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var props = item.properties || {};
      if (props[BRINDE_PROP] === "true" || props[BRINDE_PROP] === true) {
        return item;
      }
    }
    return null;
  }

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  }

  function syncCouponAttribute(code) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        attributes: (function () {
          var a = {};
          a[ATTR_KEY] = code || "";
          return a;
        })(),
      }),
    }).then(function (r) {
      return r.json();
    });
  }

  function removeGiftItem(itemId) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ updates: (function () { var u = {}; u[itemId] = 0; return u; })() }),
    }).then(function (r) {
      return r.json();
    });
  }

  function addGiftItem(variantId, code) {
    var props = {};
    props[BRINDE_PROP] = "true";
    if (code) props[BRINDE_COUPON_PROP] = code;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: props }],
      }),
    }).then(function (r) {
      return r.json();
    });
  }

  function refreshMinicart(cart) {
    if (window.renderMinicart) {
      try {
        window.renderMinicart(cart);
        return;
      } catch (e) {}
    }
    fetchCart().then(function (c) {
      if (window.renderMinicart) window.renderMinicart(c);
    });
  }

  function showToast(msg) {
    var existing = document.querySelector(".minicart-toast");
    if (existing) existing.remove();
    var el = document.createElement("div");
    el.className = "minicart-toast";
    el.textContent = msg;
    var host = document.querySelector(".minicart-content") || document.body;
    host.appendChild(el);
    setTimeout(function () {
      el.classList.add("is-visible");
    }, 10);
    setTimeout(function () {
      el.classList.remove("is-visible");
      setTimeout(function () {
        el.remove();
      }, 300);
    }, 3500);
  }

  function updateCheckoutLink() {
    var link = document.querySelector('.minicart-footer-actions a[href*="checkout"]');
    if (!link) return;
    if (state.coupon) {
      link.href = "/checkout?discount=" + encodeURIComponent(state.coupon);
    } else {
      link.href = "/checkout";
    }
  }

  function setMessage(text, kind) {
    var msg = document.querySelector("[data-gift-coupon-msg]");
    if (!msg) return;
    if (!text) {
      msg.hidden = true;
      msg.textContent = "";
      msg.className = "minicart-coupon__msg";
      return;
    }
    msg.hidden = false;
    msg.textContent = text;
    msg.className = "minicart-coupon__msg is-" + (kind || "info");
  }

  function setAppliedUI(code) {
    var input = document.querySelector(".minicart-coupon__input");
    var applyBtn = document.querySelector("[data-gift-coupon-apply]");
    var applied = document.querySelector(".minicart-coupon__applied");
    var codeEl = document.querySelector("[data-gift-coupon-code]");
    if (code) {
      if (input) input.parentElement && (input.parentElement.style.display = "none");
      if (applyBtn) applyBtn.style.display = "none";
      if (applied) applied.hidden = false;
      if (codeEl) codeEl.textContent = code;
    } else {
      var row = document.querySelector(".minicart-coupon__row");
      if (row) row.style.display = "";
      if (input) {
        input.value = "";
        input.parentElement && (input.parentElement.style.display = "");
      }
      if (applyBtn) applyBtn.style.display = "";
      if (applied) applied.hidden = true;
      if (codeEl) codeEl.textContent = "";
    }
  }

  function renderLockedMessage(cart) {
    var locked = document.querySelector("[data-gift-locked]");
    var block = document.querySelector("[data-gift-block]");
    var promo = document.querySelector("[data-gift-promo]");
    if (!locked || !block || !promo || !config) return;

    var min = config.min || 0;
    var total = cart ? cart.total_price : 0;
    var remaining = Math.max(0, min - total);

    if (remaining > 0) {
      block.hidden = false;
      var template =
        promo.getAttribute("data-locked-text") ||
        "Faltam {{remaining}} para liberar seu brinde";
      locked.hidden = false;
      locked.textContent = template.replace("{{remaining}}", formatMoneyBR(remaining));
      var list = document.querySelector("[data-gift-list]");
      if (list) list.hidden = true;
    } else {
      locked.hidden = true;
      var list2 = document.querySelector("[data-gift-list]");
      if (list2) list2.hidden = false;
    }
  }

  function shouldShowGifts(cart) {
    if (!config || !config.enabled) return false;
    if (!isWithinDateRange()) return false;
    if (!state.coupon) return false;
    if (!cart) return false;
    return cart.total_price >= (config.min || 0);
  }

  function getProductFromConfig(productId) {
    if (!config || !config.products) return null;
    for (var i = 0; i < config.products.length; i++) {
      if (String(config.products[i].id) === String(productId)) return config.products[i];
    }
    return null;
  }

  function findVariantByOptions(product, selected) {
    if (!product || !product.variants) return null;
    var keys = Object.keys(selected);
    if (keys.length === 0) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var p = 0; p < (product.options || []).length; p++) {
        var pos = p + 1;
        var optName = "option" + pos;
        var expected = selected[optName];
        if (typeof expected === "undefined") {
          match = false;
          break;
        }
        if (v.options[p] !== expected) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function updateAddBtnForItem(itemEl, product) {
    var addBtn = itemEl.querySelector("[data-gift-add]");
    if (!addBtn) return;
    if (product.has_only_default_variant) {
      var v = product.variants && product.variants[0];
      if (v && v.available) {
        addBtn.hidden = false;
        addBtn.disabled = false;
        addBtn.dataset.variantId = v.id;
      } else {
        addBtn.hidden = true;
      }
      return;
    }
    var selected = state.selectedVariantByProduct[product.id] || {};
    var requiredOptions = (product.options || []).length;
    var pickedCount = Object.keys(selected).length;

    if (pickedCount < requiredOptions) {
      addBtn.hidden = true;
      addBtn.disabled = true;
      addBtn.removeAttribute("data-variant-id");
      return;
    }

    var variant = findVariantByOptions(product, selected);
    if (variant && variant.available) {
      addBtn.hidden = false;
      addBtn.disabled = false;
      addBtn.dataset.variantId = variant.id;
    } else {
      addBtn.hidden = false;
      addBtn.disabled = true;
      addBtn.removeAttribute("data-variant-id");
      addBtn.textContent = variant ? "Variante indisponível" : "Selecione todas as opções";
    }
  }

  function bindGiftItemEvents() {
    var items = document.querySelectorAll("[data-gift-item]");
    items.forEach(function (itemEl) {
      var productId = itemEl.dataset.productId;
      var product = getProductFromConfig(productId);
      if (!product) return;

      var toggle = itemEl.querySelector("[data-gift-toggle]");
      var variants = itemEl.querySelector(".minicart-gifts__variants");
      var addBtn = itemEl.querySelector("[data-gift-add]");

      if (toggle && !toggle.dataset.bound) {
        toggle.dataset.bound = "1";
        toggle.addEventListener("click", function () {
          var siblings = document.querySelectorAll("[data-gift-item]");
          siblings.forEach(function (sib) {
            if (sib !== itemEl) {
              sib.classList.remove("is-open");
              var sb = sib.querySelector("[data-gift-toggle]");
              var sv = sib.querySelector(".minicart-gifts__variants");
              var sa = sib.querySelector("[data-gift-add]");
              if (sb) sb.setAttribute("aria-expanded", "false");
              if (sv) sv.hidden = true;
              if (sa) sa.hidden = true;
            }
          });

          var isOpen = itemEl.classList.toggle("is-open");
          toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
          if (variants) variants.hidden = !isOpen;
          if (isOpen) {
            updateAddBtnForItem(itemEl, product);
          } else if (addBtn) {
            addBtn.hidden = true;
          }
        });
      }

      var optionBtns = itemEl.querySelectorAll(".minicart-gifts__option-value");
      optionBtns.forEach(function (btn) {
        if (btn.dataset.bound) return;
        btn.dataset.bound = "1";
        btn.addEventListener("click", function () {
          var optionWrap = btn.closest(".minicart-gifts__option");
          var pos = optionWrap ? parseInt(optionWrap.dataset.optionPosition, 10) : null;
          if (!pos) return;
          optionWrap
            .querySelectorAll(".minicart-gifts__option-value")
            .forEach(function (b) {
              b.classList.remove("is-selected");
            });
          btn.classList.add("is-selected");

          if (!state.selectedVariantByProduct[product.id]) {
            state.selectedVariantByProduct[product.id] = {};
          }
          state.selectedVariantByProduct[product.id]["option" + pos] = btn.dataset.optionValue;
          updateAddBtnForItem(itemEl, product);
        });
      });

      if (addBtn && !addBtn.dataset.bound) {
        addBtn.dataset.bound = "1";
        addBtn.addEventListener("click", function () {
          var variantId = addBtn.dataset.variantId;
          if (!variantId) return;
          handleAddGift(variantId);
        });
      }
    });
  }

  function handleAddGift(variantId) {
    var code = state.coupon;
    var openCart = document.querySelector("#cartAction");
    var block = document.querySelector("[data-gift-block]");
    if (block) block.classList.add("is-loading");

    fetchCart()
      .then(function (cart) {
        var existing = findGiftItem(cart);
        if (existing) {
          return removeGiftItem(existing.key || existing.id);
        }
        return cart;
      })
      .then(function () {
        return addGiftItem(variantId, code);
      })
      .then(function (result) {
        if (result && result.status && result.status >= 400) {
          showToast(result.description || "Não foi possível adicionar o brinde");
          return null;
        }
        return fetchCart();
      })
      .then(function (cart) {
        state.forceExpanded = false;
        state.selectedVariantByProduct = {};
        if (cart) refreshMinicart(cart);
        if (openCart) openCart.checked = true;
      })
      .catch(function () {
        showToast("Erro ao adicionar o brinde");
      })
      .then(function () {
        if (block) block.classList.remove("is-loading");
      });
  }

  function handleApplyCoupon() {
    var input = document.querySelector(".minicart-coupon__input");
    if (!input) return;
    var entered = normalizeCode(input.value);
    if (!entered) {
      setMessage("Digite um cupom", "error");
      return;
    }

    state.coupon = entered;
    setStoredCoupon(entered);
    setAppliedUI(entered);
    setMessage("", null);
    updateCheckoutLink();

    if (config && config.enabled) {
      var expected = normalizeCode(config.coupon);
      if (entered === expected) {
        if (!isWithinDateRange()) {
          setMessage("Esta promoção não está mais disponível", "info");
          return;
        }
        syncCouponAttribute(entered)
          .then(function (cart) {
            return cart || fetchCart();
          })
          .then(function (cart) {
            renderState(cart);
          });
        return;
      }
    }

    showToast("Cupom aplicado");
  }

  function handleRemoveCoupon() {
    state.coupon = null;
    state.forceExpanded = false;
    setStoredCoupon(null);
    setAppliedUI(null);
    updateCheckoutLink();

    fetchCart()
      .then(function (cart) {
        var gift = findGiftItem(cart);
        if (gift) return removeGiftItem(gift.key || gift.id);
        return cart;
      })
      .then(function () {
        return syncCouponAttribute("");
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        refreshMinicart(cart);
        showToast("Cupom removido");
      });
  }

  function bindCouponEvents() {
    var applyBtn = document.querySelector("[data-gift-coupon-apply]");
    var removeBtn = document.querySelector("[data-gift-coupon-remove]");
    var input = document.querySelector(".minicart-coupon__input");

    if (applyBtn && !applyBtn.dataset.bound) {
      applyBtn.dataset.bound = "1";
      applyBtn.addEventListener("click", handleApplyCoupon);
    }

    if (input && !input.dataset.bound) {
      input.dataset.bound = "1";
      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          handleApplyCoupon();
        }
      });
    }

    if (removeBtn && !removeBtn.dataset.bound) {
      removeBtn.dataset.bound = "1";
      removeBtn.addEventListener("click", handleRemoveCoupon);
    }
  }

  function maybeRemoveInvalidGift(cart) {
    if (!cart) return Promise.resolve(cart);
    var gift = findGiftItem(cart);
    if (!gift) return Promise.resolve(cart);
    var couponOk = !!state.coupon;
    var dateOk = isWithinDateRange();
    var brindeLinePrice = gift.line_price || 0;
    var totalSemBrinde = (cart.total_price || 0) - brindeLinePrice;
    var minOk = totalSemBrinde >= (config.min || 0);

    if (couponOk && dateOk && minOk) return Promise.resolve(cart);

    return removeGiftItem(gift.key || gift.id).then(function (newCart) {
      state.forceExpanded = false;
      var motivo = !couponOk
        ? "Cupom removido"
        : !dateOk
        ? "Promoção encerrada"
        : "Valor mínimo não atingido";
      showToast("Brinde removido: " + motivo.toLowerCase());
      if (window.renderMinicart) window.renderMinicart(newCart);
      return newCart;
    });
  }

  function renderState(cart) {
    var promo = document.querySelector("[data-gift-promo]");
    if (!promo || !config || !config.enabled) return;

    updateCheckoutLink();

    if (!isWithinDateRange()) {
      promo.hidden = true;
      return;
    }

    promo.hidden = false;

    if (state.coupon) {
      setAppliedUI(state.coupon);
    } else {
      setAppliedUI(null);
    }

    var block = document.querySelector("[data-gift-block]");
    var selected = document.querySelector("[data-gift-selected]");
    var gift = findGiftItem(cart);

    if (!state.coupon) {
      if (block) block.hidden = true;
      if (selected) selected.hidden = true;
      return;
    }

    if (gift && !state.forceExpanded) {
      if (block) block.hidden = true;
      if (selected) {
        selected.hidden = false;
        var titleEl = selected.querySelector("[data-gift-selected-title]");
        if (titleEl) {
          var label = gift.product_title || gift.title || "";
          if (gift.variant_title && gift.variant_title !== "Default Title") {
            label += " - " + gift.variant_title;
          }
          titleEl.textContent = label;
        }
      }
      bindChangeGiftButton();
      return;
    }

    if (block) {
      block.hidden = false;
      renderLockedMessage(cart);
      var list = document.querySelector("[data-gift-list]");
      if (list) {
        list.querySelectorAll("[data-gift-item]").forEach(function (li) {
          li.classList.toggle(
            "is-current-gift",
            gift && String(gift.product_id) === String(li.dataset.productId)
          );
        });
      }
      bindGiftItemEvents();
    }
    if (selected) selected.hidden = true;
  }

  function bindChangeGiftButton() {
    var btn = document.querySelector("[data-gift-change]");
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = "1";
    btn.addEventListener("click", function () {
      state.forceExpanded = true;
      fetchCart().then(function (cart) {
        renderState(cart);
      });
    });
  }

  function syncFromCart(cart) {
    if (!cart) return;

    var attrs = cart.attributes || {};
    var attrCoupon = attrs[ATTR_KEY] ? normalizeCode(attrs[ATTR_KEY]) : null;
    var stored = normalizeCode(getStoredCoupon());
    var picked = attrCoupon || stored || null;

    if (!picked) {
      state.coupon = null;
      return;
    }

    if (config && config.enabled) {
      var expected = normalizeCode(config.coupon);
      if (picked === expected && !isWithinDateRange()) {
        state.coupon = null;
        setStoredCoupon(null);
        return;
      }
    }

    state.coupon = picked;
    setStoredCoupon(picked);
  }

  function onCartRender(cart) {
    if (!config) config = readConfig();

    if (!state.coupon) {
      var stored = normalizeCode(getStoredCoupon());
      if (stored) state.coupon = stored;
    }

    bindCouponEvents();
    setAppliedUI(state.coupon);
    updateCheckoutLink();

    if (!config || !config.enabled) return;

    syncFromCart(cart);
    maybeRemoveInvalidGift(cart).then(function (final) {
      renderState(final || cart);
    });
  }

  function init() {
    config = readConfig();

    var stored = normalizeCode(getStoredCoupon());
    if (stored) {
      state.coupon = stored;
      setAppliedUI(stored);
      updateCheckoutLink();
    }

    bindCouponEvents();

    if (!config || !config.enabled) return;

    fetchCart().then(function (cart) {
      syncFromCart(cart);
      maybeRemoveInvalidGift(cart).then(function (final) {
        renderState(final || cart);
      });
    });
  }

  window.GiftPromo = {
    init: init,
    onCartRender: onCartRender,
    getCoupon: function () {
      return state.coupon;
    },
    isActive: function () {
      return !!(config && config.enabled && state.coupon && isWithinDateRange());
    },
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
